import type { EChartsOption } from "echarts";
import EChartBase from "./EChartBase";
import { defaultChartColors } from "./ChartTheme";

export type TrendDatum = {
  label: string | number;
  value?: number;
  budget?: number;
  actual?: number;
  forecast?: number;
};

type Props = {
  data: TrendDatum[];
  height?: number | string;
};

export default function LineTrendChart({ data, height = 320 }: Props) {
  const labels = data.map((x) => x.label);
  const hasBudgetActual = data.some((x) => x.budget !== undefined || x.actual !== undefined);

  const series = hasBudgetActual
    ? [
        { name: "Budget", type: "line", smooth: true, data: data.map((x) => x.budget ?? 0) },
        { name: "Actual", type: "line", smooth: true, data: data.map((x) => x.actual ?? 0) },
        ...(data.some((x) => x.forecast !== undefined)
          ? [{ name: "Forecast", type: "line", smooth: true, data: data.map((x) => x.forecast ?? null) }]
          : []),
      ]
    : [{ name: "Value", type: "line", smooth: true, data: data.map((x) => x.value ?? 0) }];

  const option: EChartsOption = {
    color: defaultChartColors,
    tooltip: { trigger: "axis" },
    legend: { top: 0 },
    grid: { left: 45, right: 20, top: 50, bottom: 35 },
    xAxis: { type: "category", data: labels },
    yAxis: { type: "value" },
    series: series as any,
  };

  return <EChartBase option={option} height={height} empty={!data?.length} />;
}